const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNTE5LCJjb25ncmVzc0lkIjoxMjk1LCJkYXRlIjoiMjAyMi0wOC0yNlQxMjo0MTo0MS43NzZaIiwiaWF0IjoxNjYxNTE3NzAxfQ.2P1HQ-JwCJkaoL90N61kpDmWx5CSC0YKLogfwlUqJAs';
const PLANNER_API_URL = 'https://dgi2022.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo0NjAsImNvbmdyZXNzSWQiOjEyMjQsImRhdGUiOiIyMDIwLTA4LTMxVDA4OjQzOjEyLjQ3OVoiLCJpYXQiOjE1OTg4NjMzOTJ9.WSdU3crc9SotMIR2B6oiAo67uOFQg-rqIbbZ_tiOb3Y';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1209;
const SUBMISSION_SYSTEM_URL = 'https://dgi2022.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_SYSTEM_URL,
  SESSION_GROUP_ID,
}